import * as React from 'react';
import cx from 'classnames';
import style from './Carousel.css';
import {isMobile} from '_utils';

const itemCount = isMobile ? 1 : 3;

const getWidth = (element) => {
    const style = element.currentStyle || window.getComputedStyle(element),
        width = element.offsetWidth, // or use style.width
        margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
        padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
        border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
    return width + margin + padding + border;

};

export class Carousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pos: 0,
            count: 1,
            offset: 1
        };
    }

    componentDidMount() {
        setTimeout(() => {
            const count = Math.ceil(this.props.children.length / itemCount) - 1;
            const offset = getWidth(this.content.lastChild) / (getWidth(this.content) / 100);
            this.setState({count, offset});
        }, 2500);

    }

    handleClickNext = () => {
        if (this.state.pos >= this.state.count) {
            return;
        }

        this.setState({
            pos: this.state.pos + 1
        });
    };

    handleClickPrev = () => {
        if (this.state.pos < 1) {
            return;
        }

        this.setState({
            pos: this.state.pos - 1
        });
    };

    render() {
        return (
            <div className={style.carousel}>
                <button
                    className={cx(style.prev, {[style.hide]: this.state.pos < 1})}
                    onClick={this.handleClickPrev}
                />
                <button
                    className={cx(style.next, {[style.hide]: this.state.pos >= this.state.count})}
                    onClick={this.handleClickNext}
                />
                <div ref={c => this.root = c} className={style.wrap}>
                    <div
                        ref={c => this.content = c}
                        className={style.content}
                        style={{transform: `translateX(-${this.state.pos * this.state.offset}%)`}}
                    >
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}